import { ChipVariants } from "components/Chip";

export const adjustmentTypesConstants = {
  MPDR: "MPDR",
  NCCI: "NCCI",
  BILATERAL: "Bilateral",
  CASE_RATE: "Case Rate",
  ENDOSCOPY: "Endoscopy",
  BILATERAL_MPDR: "Bilateral + MPDR",
  ENDOSCOPY_MPDR: "Endoscopy + MPDR",
  PACKAGED_CODE: "Packaged Code",
};

export const adjustmentTypesMapping = {
  [adjustmentTypesConstants.MPDR]: "Multiple Procedure Discount Applied",
  [adjustmentTypesConstants.NCCI]: "National Coding Correction Applied",
  [adjustmentTypesConstants.BILATERAL]:
    "Bilateral Procedure Adjustment Applied",
  [adjustmentTypesConstants.CASE_RATE]: "Case Rate Adjustment Applied",
  [adjustmentTypesConstants.ENDOSCOPY]: "Base Endoscopy Adjustment Applied",
  [adjustmentTypesConstants.BILATERAL_MPDR]:
    "Bilateral + Multiple Procedure Discounts Applied",
  [adjustmentTypesConstants.ENDOSCOPY_MPDR]:
    "Endoscopy + Multiple Procedure Discounts Applied",
  [adjustmentTypesConstants.PACKAGED_CODE]: "Packaged Code",
};

export const orderTypeConstants = {
  ED: "ED",
  BUNDLED: "Bundled",
  PATIENT_RESPONSIBILITY: "PatientResponsibility",
  BARIATRICS: "Bariatrics",
  GFE: "GFE",
};

export const orderStatusConstants = {
  PAID: "Paid",
  EXPIRED: "Expired",
  DELETED: "Deleted",
  REFUNDED: "Refunded",
  SENT_TO_PATIENT: "SentToPatient",
  CANCELED: "Canceled",
  DRAFT: "Draft",
  PARTIALLY_PAID: "PartiallyPaid",
  NO_BALANCE_DUE: "NoBalanceDue",
  PAID_VIA_CASH_UNMANAGED: "PaidViaCashUnmanaged",
};

export const orderStatusMapping = {
  [orderStatusConstants.SENT_TO_PATIENT]: "Sent",
  [orderStatusConstants.DELETED]: "Deleted",
  [orderStatusConstants.EXPIRED]: "Expired",
  [orderStatusConstants.PAID]: "Paid",
  [orderStatusConstants.PARTIALLY_PAID]: "Partially Paid",
  [orderStatusConstants.REFUNDED]: "Refunded",
  [orderStatusConstants.CANCELED]: "Canceled",
  [orderStatusConstants.DRAFT]: "Pending Review",
  [orderStatusConstants.NO_BALANCE_DUE]: "No Balance Due",
  [orderStatusConstants.PAID_VIA_CASH_UNMANAGED]: "Paid via Cash",
};

export const orderStatusChipVariantsMapping = {
  [orderStatusConstants.SENT_TO_PATIENT]: ChipVariants.WARNING,
  [orderStatusConstants.DELETED]: ChipVariants.WARNING,
  [orderStatusConstants.EXPIRED]: ChipVariants.EXPIRED,
  [orderStatusConstants.PAID]: ChipVariants.SUCCESS,
  [orderStatusConstants.PARTIALLY_PAID]: ChipVariants.WARNING,
  [orderStatusConstants.REFUNDED]: ChipVariants.EXPIRED,
  [orderStatusConstants.CANCELED]: ChipVariants.EXPIRED,
  [orderStatusConstants.DRAFT]: ChipVariants.EXPIRED,
  [orderStatusConstants.NO_BALANCE_DUE]: ChipVariants.EXPIRED,
  [orderStatusConstants.PAID_VIA_CASH_UNMANAGED]: ChipVariants.SUCCESS,
};

export const orderTypeMapping = {
  [orderTypeConstants.ED]: "ER",
  [orderTypeConstants.BARIATRICS]: "Bariatrics",
  [orderTypeConstants.BUNDLED]: "Clear Package",
  [orderTypeConstants.PATIENT_RESPONSIBILITY]: "Patient Responsibility",
  [orderTypeConstants.GFE]: "Clear Estimate Pro",
};

export const orderTypeShortMapping = {
  [orderTypeConstants.ED]: "ER",
  [orderTypeConstants.BARIATRICS]: "Bariatrics",
  [orderTypeConstants.BUNDLED]: "Clear Package",
  [orderTypeConstants.PATIENT_RESPONSIBILITY]: "Pt Resp",
  [orderTypeConstants.GFE]: "Estimate Pro",
};

export const ED_ORDER_TYPE_EXPIRATION_PERIOD = 10;

export const payerTypeConstants = {
  COMMERCIAL: "Commercial",
  MEDICARE_ADVANTAGE: "UhcMedicareAdvantage",
  MEDICARE: "OriginalMedicare",
};
